import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import Center from "./Center";
import JunoLogo from "./JunoLogo";
import { mediaQueries } from "../styles/media.js";

const JunoFooter = styled.footer`
  font-family: var(--juno-font-family-body);

  background-color: ${(props) => (props.reversed ? "var(--juno-color-footer-reversed)" : "var(--juno-color-footer)")};

  /* theme footer links */
  a {
    text-decoration: none;
  }

  a:link,
  a:visited {
    color: ${(props) => (props.reversed ? "var(--juno-color-link-reversed-active)" : "var(--juno-color-footer-text)")};
  }

  a:hover,
  a:active {
    color: ${(props) => (props.reversed ? "var(--juno-color-link-reversed-hover)" : "var(--juno-color-link-hover)")};
  }

  /* theme Juno text */
  color: ${(props) => (props.reversed ? "var(--juno-color-text-reversed)" : "var(--juno-color-footer-text)")};

  /* theme address */
  address {
    color: ${(props) => (props.reversed ? "var(--juno-color-text-reversed)" : "var(--juno-color-footer-text)")};
  }

  /* theme Smallprint */
  p {
    color: ${(props) =>
      props.reversed ? "var(--juno-color-text-reversed-secondary)" : "var(--juno-color-text-secondary)"};
  }
`;

const JunoFooterInner = styled(Center)`
  padding-top: 32px;
  padding-bottom: 32px;
`;

const JunoFooterText = styled.p`
  font-size: var(--juno-font-size-body-sm);
  line-height: 1.5rem;

  font-weight: var(--juno-font-weight-light);
  letter-spacing: normal;
  text-decoration: inherit;
  text-transform: inherit;

  margin-top: 0;
  margin-bottom: 0.75rem;

  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
    line-height: 1.75rem;

    margin-bottom: 1rem;
  }
`;

const JunoFooterAddress = styled(JunoFooterText)`
  color: inherit;
  font-style: normal;

  margin-top: 1rem;

  ${mediaQueries.md} {
    margin-top: 1.75rem;
  }
`;

const JunoFooterSection = styled.section`
  margin-bottom: 3em;
`;

const Smallprint = styled.div`
  max-width: 38rem;

  p {
    font-size: 0.875rem;
    line-height: 1.5rem;
    margin-top: 1.25rem;
    margin-bottom: 0.75rem;
  }
`;

function Footer(props) {
  return (
    <JunoFooter {...props}>
      <JunoFooterInner pageWidth={props.pageWidth}>
        <JunoLogo fill={props.reversed ? "#f1f2f4" : "#002457"} />

        <JunoFooterSection>
          <JunoFooterAddress as="address">
            43-51 New North Road
            <br />
            London N1 6LU
          </JunoFooterAddress>
          <JunoFooterText>
            <a href="tel:020 3856 3339">020 3856 3339</a>
          </JunoFooterText>
          <JunoFooterText>
            <a href="mailto:hello@juno.legal">hello@juno.legal</a>
          </JunoFooterText>
          <JunoFooterText>We are open Monday to Friday, 9am to 5pm</JunoFooterText>
        </JunoFooterSection>

        <JunoFooterSection>
          <Smallprint>
            <p>
              Juno is the trading name of Juno Property Lawyers Limited, a company registered in England and Wales.
              Company number 1022 7405 &middot; &nbsp;VAT number 243 966 087
            </p>
            <p>Juno is regulated by the CLC &middot; &nbsp;Licence number 3338</p>
            <p>&copy; Juno Property Lawyers Limited</p>
          </Smallprint>
        </JunoFooterSection>
      </JunoFooterInner>
    </JunoFooter>
  );
}

export default Footer;

Footer.propTypes = {
  pageWidth: PropTypes.string.isRequired,
  reversed: PropTypes.bool.isRequired,
};
